export const FETCH_SITEMAP_IN_PROGRESS = "FETCH_SITEMAP_IN_PROGRESS";
export const FETCH_SITEMAP_SUCCESS = "FETCH_SITEMAP_SUCCESS";
export const FETCH_SITEMAP_FAILED = "FETCH_SITEMAP_FAILED";
export const GENERATE_SITEMAP_IN_PROGRESS = "GENERATE_SITEMAP_IN_PROGRESS";
export const GENERATE_SITEMAP_SUCCESS = "GENERATE_SITEMAP_SUCCESS";
export const GENERATE_SITEMAP_FAILED = "GENERATE_SITEMAP_FAILED";
